import {
  Autocomplete,
  FormHelperText,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import styles from "./AutoCompleteFeild.module.css";
import { useState } from "react";

const AutoCompleteFeild = (props) => {
  const { label, options, fieldValue, required, error, placeholder } = props;
  const [value, setValue] = useState("");

  // for suggested data
  const handleChange = (e) => {
    e.preventDefault();
    const value = e.target.innerHTML;
    fieldValue(value);
    setValue(value);
    // props.handleChange(value);
  };
  // for free typed value
  const handleChangeCap = (e) => {
    e.preventDefault();
    const value = e.target.value;
    fieldValue(value);
    setValue(value);
  };

  const handleClear = () => {
    setValue("");
    fieldValue("");
  };

  return (
    <div className="autoFeild">
      <div className={styles.FieldLabelContainer}>
        <div className={styles.FieldLabel}>
          <span>{label}</span>
          {required && <span style={{ color: "#d32f2f" }}>*</span>}&nbsp;
        </div>
        <span className={styles.FieldLabelErrorText}>
          {props.error &&
            props.FieldErrorLabel &&
            (props.FieldLabelHelperText
              ? props.FieldLabelHelperText
              : "Required")}
        </span>
      </div>
      <Autocomplete
        sx={stylefunction}
        options={options}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            error={props.error}
            // helperText={
            //   <span style={{ color: "red" }}>{props.helperText}</span>
            // }
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {value && (
                    <InputAdornment position="end">
                      <IconButton onClick={handleClear} edge="end" size="small">
                        <ClearRoundedIcon
                          fontSize="small"
                          sx={{ color: "black" }}
                        />
                      </IconButton>
                    </InputAdornment>
                  )}
                  {params.InputProps.endAdornment}
                  <InputAdornment position="end">
                    <ArrowDropDownRoundedIcon sx={{ color: "black" }} />
                  </InputAdornment>
                </>
              ),
            }}
          />
        )}
        freeSolo
        handleHomeEndKeys
        onChange={handleChange} // for suggested data
        onChangeCapture={handleChangeCap} // for free typed value
        value={value}
        disableClearable={true}
      />
      <FormHelperText error>{props.helperText}</FormHelperText>
    </div>
  );
};

export default AutoCompleteFeild;

// css part
const stylefunction = {
  mt: 1,
  "& label": {
    color: "#676C7B",
    marginTop: "-40px",
    marginLeft: "-14px",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#E4E8EC",
      borderWidth: "2px",
    },
  },
  "& .MuiOutlinedInput-root:hover": {
    "& fieldset": {
      borderColor: "black",
      borderWidth: "1px",
    },
  },
  "& .MuiOutlinedInput-root:focus": {
    "& fieldset": {
      borderColor: "primary.main",
    },
  },
  "& .MuiAutocomplete-endAdornment": {
    marginTop: "4px",
    display: "flex",
    alignItems: "center",
    color: "black",
  },
};

//  component like

// this array needs to be global
// const globalArray = ["option 1", "option 2", "option 3"];

// this is the function to get value
// const fieldValue = (data) => {
//   console.log('data coming from new com:',data);
// }

// this is the component
{
  /* 
<AutoCompleteFeild
  label="field name"
  options={globalArray}
  fieldValue={fieldValue}
/>; 
*/
}
